import { Button } from '@creditornot/cb-button';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography } from 'common/typography';

import {
  ScreenCenteredImage,
  ScreenContainer,
  ScreenInformation,
  ScreenHeader,
  ScreenActionsContainer,
} from './screens.styled';
import ReceiptImage from '../../../images/receipt.png';

export const Download = ({ onBack }: { onBack: () => void }) => (
  <ScreenContainer>
    <ScreenCenteredImage src={ReceiptImage} />
    <ScreenInformation>
      <ScreenHeader>
        <FormattedMessage id="insights.reports.download.title" />
      </ScreenHeader>
      <Typography.Body3>
        <FormattedMessage
          id="insights.reports.download.description"
          values={{
            link: (text: string) => (
              <a href={'/link-to-be-done'} target="_blank" rel="noreferrer">
                {text}
              </a>
            ),
          }}
        />
      </Typography.Body3>
      <Typography.Body3>
        <FormattedMessage id="insights.reports.download.enjoy" />
      </Typography.Body3>
    </ScreenInformation>
    <ScreenActionsContainer>
      <Button variant="blue" size="small" onClick={onBack}>
        <FormattedMessage id="insights.reports.result.back-to-insights" />
      </Button>
    </ScreenActionsContainer>
  </ScreenContainer>
);
